import React, { PureComponent } from 'react';
import { Popover, Button } from 'antd';
import ActionPopver from "./ActionPopver";
import ReactEcharts from 'echarts-for-react';
import styles from "./temperature.module.less";

export default class Temperature extends PureComponent {

    state = {
        popVisible: false,
        popKey: 0,
    }
    onSubmit = (data) => {
        const { onActionSubmit } = this.props;
        onActionSubmit && onActionSubmit(data, _ => this.setState({ popVisible: false }))
    }

    renderPopverContent = () => {
        const { filed, data, action, defaultValue, deviceId, onActionSubmit, loadDefaultValue } = this.props;
        const { MaxThr = {}, AlarmSw = {} } = data || {}
        const max = MaxThr.value;
        const alarmSw = AlarmSw.value;
        return <div>
            <ActionPopver action={action} onSubmit={this.onSubmit} defaultValue={defaultValue}
                loadDefaultValue={loadDefaultValue} deviceId={deviceId} />
        </div>

    }

    render() {
        const { popVisible, popKey } = this.state;
        const { filed, bgColor, action } = this.props;

        let { value } = (this.props.data || {}).Value || {} || { value: 38 }
        let kd = [];
        // 刻度使用柱状图模拟，短设置3，长的设置5；构造一个数据
        for (let i = 0, len = 105; i <= len; i++) {
            if (i > 110 || i < 10) {
                kd.push('0')
            } else {
                if (i % 20 === 0) {
                    kd.push(0.3 * window.fontSize);
                } else if (i % 10 === 0) {
                    kd.push(0.25 * window.fontSize);
                }
                else {
                    kd.push(0);
                }
            }

        }

        let data = [value];
        let mercuryColor = '#fd4d49';
        let borderColor = '#fd4d49';
        let option = {
            title: {
                text: '温度计',
                show: false
            },
            grid: {
                left: 0, right: 0, top: 0, bottom: 0.20 * window.fontSize
            },
            yAxis: [
                { show: false, min: 0, max: 120, },
                { show: false, data: [], min: 0, max: 120, }
            ],
            xAxis: [
                { show: false, data: [] },
                { show: false, data: [] },
                { show: false, data: [] },
                { show: false, min: -110, max: 100, }
            ],
            series: [
                {
                    name: '条',
                    type: 'bar',
                    // 对应上面XAxis的第一个对象配置
                    xAxisIndex: 0,
                    data: data,
                    barWidth: 0.06 * window.fontSize,
                    itemStyle: {
                        normal: {
                            color: mercuryColor,
                            barBorderRadius: 0,
                        }
                    },
                    label: {
                        normal: {
                            show: false,
                            position: 'top',
                            formatter: function (param) {
                                // 因为柱状初始化为0，温度存在负值，所以，原本的0-100，改为0-130，0-30用于表示负值
                                return param.value + '℃';
                            },
                            textStyle: {
                                color: '#ccc',
                                fontSize: '10',
                            }
                        }
                    },
                    z: 2
                },
                {
                    name: '白框',
                    type: 'bar',
                    xAxisIndex: 1,
                    barGap: '-100%',
                    data: [110],
                    barWidth: 0.11 * window.fontSize,
                    itemStyle: {
                        normal: {
                            color: '#ffffff',
                            barBorderRadius: 50,
                        }
                    },
                    z: 1
                },
                {
                    name: '外框',
                    type: 'bar',
                    xAxisIndex: 2,
                    barGap: '-100%',
                    data: [113],
                    barWidth: 0.18 * window.fontSize,
                    itemStyle: {
                        normal: {
                            color: borderColor,
                            barBorderRadius: 50,
                        }
                    },
                    z: 0
                },
                {
                    name: '圆',
                    type: 'scatter',
                    hoverAnimation: false,
                    data: [0],
                    xAxisIndex: 0,
                    symbolSize: 0.18 * window.fontSize,
                    itemStyle: {
                        normal: {
                            color: mercuryColor,
                            opacity: 1,
                        }
                    },
                    z: 2
                },
                {
                    name: '白圆',
                    type: 'scatter',
                    hoverAnimation: false,
                    data: [0],
                    xAxisIndex: 1,
                    symbolSize: 0.23 * window.fontSize,
                    itemStyle: {
                        normal: {
                            color: '#ffffff',
                            opacity: 1,
                        }
                    },
                    z: 1
                },
                {
                    name: '外圆',
                    type: 'scatter',
                    hoverAnimation: false,
                    data: [0],
                    xAxisIndex: 2,
                    symbolSize: 0.30 * window.fontSize,
                    itemStyle: {
                        normal: {
                            color: borderColor,
                            opacity: 1,
                        }
                    },
                    z: 0
                },
                {
                    name: '刻度',
                    type: 'bar',
                    yAxisIndex: 1,
                    xAxisIndex: 3,
                    label: {
                        normal: {
                            show: true,
                            position: 'right',
                            distance: 0.12 * window.fontSize,
                            color: '#aaa',
                            fontSize: 0.1 * window.fontSize,
                            formatter: function (params) {
                                // 因为柱状初始化为0，温度存在负值，所以，原本的0-100，改为0-130，0-30用于表示负值
                                if (params.dataIndex > 110 || params.dataIndex < 5) {
                                    return '';
                                } else {
                                    if (params.dataIndex % 20 === 0) {
                                        return params.dataIndex;
                                    } else {
                                        return '';
                                    }
                                }
                            }
                        }
                    },
                    barGap: '-100%',
                    data: kd,
                    barWidth: 0.02 * window.fontSize,
                    itemStyle: {
                        normal: {
                            color: borderColor,
                            barBorderRadius: 10,
                        }
                    },
                    z: 0
                }
            ]
        };

        return (
            <div className={styles.main}>
                <div className={styles.charts}>
                    <ReactEcharts option={option} style={{ height: '100%', width: '100%' }} />
                </div>
                <div className={styles.info}>
                    <div className={styles.value}>{filed}:{value || 0}℃</div>
                    {action ?
                        <Popover key={popKey} trigger="click" visible={popVisible}
                            content={this.renderPopverContent()}
                            onVisibleChange={(popVisible) => this.setState({ popVisible, popKey: popKey + 1 })}>
                            <Button type="primary" className={styles.button}>设置</Button>
                        </Popover>
                        : ''
                    }
                </div>
            </div>
        )

    }

}